import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import fi from './locales/fi.json'
import sv from './locales/sv.json'
import en from './locales/en.json'

// Finnish is the club's language and the fallback: the legacy UI was
// entirely Finnish, and a missing translation should show Finnish rather
// than an English string or a raw key.
export const SUPPORTED_LOCALES = ['fi', 'sv', 'en'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  fi: 'Suomi',
  sv: 'Svenska',
  en: 'English',
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fi: { translation: fi },
      sv: { translation: sv },
      en: { translation: en },
    },
    fallbackLng: 'fi',
    supportedLngs: [...SUPPORTED_LOCALES],
    // Without this, a browser reporting "fi-FI" would miss the "fi" bundle.
    load: 'languageOnly',
    interpolation: { escapeValue: false }, // React escapes already
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'jupi.locale',
      caches: ['localStorage'],
    },
  })

// The signed-in member's stored preference wins over what the browser
// reports -- it is an explicit choice, saved on their account.
export function applyUserLocale(locale: string | undefined) {
  if (!locale || i18n.language === locale) return
  if (!(SUPPORTED_LOCALES as readonly string[]).includes(locale)) return
  void i18n.changeLanguage(locale)
}

export default i18n
